import React, {useEffect} from 'react'
import {JsonViewer} from '../../../../../../../common/JsonViewer.jsx'
import {HeaderTitle} from '../../../../../../../common/HeaderTitle.jsx'
import TextareaWiz from "../../../../../../../common/inputs/wizard/TextareaWiz.jsx";
import SelectWiz from "../../../../../../../common/inputs/wizard/SelectWiz.jsx";
import RadioWiz from "../../../../../../../common/inputs/wizard/RadioWiz.jsx";
import DateTimeWiz from "../../../../../../../common/inputs/wizard/DateTimeWiz.jsx";
import {optionsProjektStatusSpr, optionsTakNie} from "../../../../../../../utils/options.js";

const DanePodstawowe = (props) => {
    const wiz = props.wiz
    const form = wiz?.form || {}

    const isKomitet = form.czy_komitet === 'Tak'

    useEffect(() => {
        if (form.projekt_status_spr === undefined || form.projekt_status_spr === null) {
            wiz?.setValue?.('projekt_status_spr', '')
        }
    }, [form.projekt_status_spr])

    return (
        <div>
            <JsonViewer src={wiz?.form || {}} show={false}/>
            <HeaderTitle noHr size={'fs-3'} title={'A. Dane podstawowe'}/>

            <div className={'d-flex flex-column gap-3'}>
                <SelectWiz
                    wiz={wiz}
                    keyName={'projekt_status_spr'}
                    label={wiz.getLabel('projekt_status_spr')}
                    options={optionsProjektStatusSpr}
                    placeholder={'Wybierz status...'}
                />

                <TextareaWiz
                    wiz={wiz}
                    keyName={'podsumowanie'}
                    label={wiz.getLabel('podsumowanie')}
                    rows={8}
                />

                <TextareaWiz
                    wiz={wiz}
                    keyName={'uwagi'}
                    label={wiz.getLabel('uwagi')}
                    rows={5}
                />

                <div className={'border p-3 rounded'}>
                    <RadioWiz
                        wiz={wiz}
                        keyName={'czy_komitet'}
                        label={wiz.getLabel('czy_komitet')}
                        options={optionsTakNie}
                    />

                    {isKomitet && (
                        <div className="mt-3">
                            <DateTimeWiz
                                wiz={wiz}
                                keyName={'data_posiedzenia_ks'}
                                hideTime
                                label={wiz.getLabel('data_posiedzenia_ks')}
                            />
                        </div>
                    )}
                </div>
            </div>
        </div>
    )
}

export default DanePodstawowe
